import { DeleteWithConfirmButton } from "ra-friendsofbabba";
import React from "react";
import useTimePermission from "../useTimePermission";

const DeleteButton = (props) => {
  const hasTimePermission = useTimePermission();
  const hasPermission = hasTimePermission(props.record);
  return (
    <DeleteWithConfirmButton
      {...props}
      disabled={props.disabled || !hasPermission}
    />
  );
};
export default DeleteButton;
